<template>
  <el-dialog
    class="dialog-wechat-merchant"
    :title="`${preTitle}微信商户`"
    :visible.sync="show"
    :close-on-click-modal="false"
    :before-close="cancel"
    width="820px"
  >
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="190px">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" label="微信商户名">
            <el-input v-model.trim="formData.name" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="mchId" label="微信商户Id">
            <el-input v-model.trim="formData.mchId" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="appId" label="开放平台appId">
            <el-input v-model.trim="formData.appId" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="apiV3Key" label="V3Key">
            <el-input v-model.trim="formData.apiV3Key" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="publicKeyId" label="公钥Id">
        <el-input v-model.trim="formData.publicKeyId" maxlength="200" />
      </el-form-item>
      <el-form-item prop="certSerialNo" label="证书编号">
        <el-input v-model.trim="formData.certSerialNo" maxlength="200" />
      </el-form-item>
      <el-form-item prop="remarks" label="备注">
        <el-input type="textarea" :rows="3" v-model.trim="formData.remarks" maxlength="200" />
      </el-form-item>
      <el-form-item prop="" label="私钥证书(apiclient_cert)" required>
        <div class="flex cert-box">
          <file-stream-upload :parent-info.sync="certData" upload-key="privateCertFile"
                              :update-flag.sync="privateCertFileFlag" />
          <el-button
            v-if="!!formData.privateCert&&!privateCertFileFlag"
            icon="el-icon-download"
            size="small"
            @click="$http.exportExcelHttp.downloadWechatShopPrivateCert(formData.id,`${formData.name}_私钥证书`)"
          >下载私钥证书文件
          </el-button>
        </div>
      </el-form-item>
      <el-form-item prop="" label="私钥(apiclient_key)" required>
        <div class="flex cert-box">
          <file-stream-upload :parent-info.sync="certData" :update-flag.sync="privateKeyFileFlag"
                              upload-key="privateKeyFile" />
          <el-button
            v-if="!!formData.privateKey&&!privateKeyFileFlag"
            icon="el-icon-download"
            size="small"
            @click="$http.exportExcelHttp.downloadWechatShopPrivateCert(formData.id,`${formData.name}_私钥`)"
          >下载私钥文件
          </el-button>
        </div>
      </el-form-item>
      <el-form-item prop="" label="公钥(pub_key)" required>
        <div class="flex cert-box">
          <file-stream-upload :parent-info.sync="certData" upload-key="publicKeyFile"
                              :update-flag.sync="publicKeyFileFlag" />
          <el-button
            v-if="!!formData.publicKey&&!publicKeyFileFlag"
            icon="el-icon-download"
            size="small"
            @click="$http.exportExcelHttp.downloadWechatShopPrivateKey(formData.id,`${formData.name}_公钥`)"
          >下载公钥文件
          </el-button>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <cancel-popover ref="cancelRef" :disabled.sync="loadData.loading" :update-flag="updateFlag" />
      <el-button type="primary" @click="handleSave">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import {
  getWechatMerchantByIdApi,
  saveWechatMerchantApi
} from '@/api/finance-manage/wechat-merchant-manage-api'
import FileStreamUpload from '@/views/pages/financeManage/wechat-merchant-manage/component/FileStreamUpload.vue'

export default {
  name: 'DialogWechatMerchant',
  components: { FileStreamUpload },
  mixins: [dialog],
  data() {
    return {
      privateCertFileFlag: false, // 判断是否已上传
      privateKeyFileFlag: false, // 判断是否已上传
      publicKeyFileFlag: false, // 判断是否已上传
      certData: new FormData(),
      formData: {
        id: '',
        // privateCertFile: {},
        // privateKeyFile: {},
        // publicKeyFile: {},
        // wxMch: {
        name: '',
        mchId: '',
        appId: '',
        apiV3Key: '',
        privateCert: '',
        privateKey: '',
        publicKey: '',
        publicKeyId: '',
        certSerialNo: '',
        remarks: ''
        // }
      },
      excludeKeys: ['privateCert', 'privateKey', 'publicKey'],
      rules: {
        name: { required: true, message: '该项为必填', trigger: 'blur' },
        mchId: { required: true, message: '该项为必填', trigger: 'blur' },
        appId: { required: true, message: '该项为必填', trigger: 'blur' },
        publicKeyId: { required: true, message: '该项为必填', trigger: 'blur' },
        certSerialNo: { required: true, message: '该项为必填', trigger: 'blur' },
        apiV3Key: { required: true, message: '该项为必填', trigger: 'blur' }
      }
    }
  },
  async mounted() {
    await this.$nextTick()
    if (this.id) {
      await this.getDataById(this.id, getWechatMerchantByIdApi)
      // this.privateCertFileFlag = !!this.formData.privateCert
      // this.privateKeyFileFlag = !!this.formData.privateKey
      // this.publicKeyFileFlag = !!this.formData.publicKey
    }
  },
  computed: {},
  methods: {
    async handleSave() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) {
          this.$message.error('请填写完整信息!')
          return
        }
        this.$confirm('此操作将保存微信商户信息, 是否继续?', '提示').then(async () => {
          if (this.formData.id) {
            this.privateCertFileFlag = !!this.formData.privateCert
            this.privateKeyFileFlag = !!this.formData.privateKey
            this.publicKeyFileFlag = !!this.formData.privateKey
          }

          if (!(this.privateCertFileFlag && this.privateKeyFileFlag && this.publicKeyFileFlag)) {
            this.$message.error('请上传私钥证书、私钥、公钥文件!')
            return
          }
          Object.keys(this.formData).forEach(key => {
            if (!this.excludeKeys.includes(key)) {
              if (key === 'remarks' && !this.formData[key]) {
                this.formData[key] = ' '
              }
              this.certData.append(key, this.formData[key])
            }
          })
          try {
            await saveWechatMerchantApi(this.certData)
            this.$emit('on-close')
            this.closed()
          } catch (e) {
            console.error(e)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.dialog-wechat-merchant {
  .cert-box {
    align-items: flex-start;
    width: 380px;
    justify-content: space-between;
  }
}
</style>
